import { OfflineConstants } from '../offline/constants';
import { deleteStoreItem, getAllStoreItems, getStoreItem, getStoreKeys, putStoreItem } from '../offline/offlineApi';

export const getCargoTemperatureConfigsItem = async (key) => await getStoreItem(OfflineConstants.stores.cargoTempLog.storeName, key);
export const getAllCargoTemperatureConfigsItems = async (imoNumber) => {
    const allItems = await getAllStoreItems(OfflineConstants.stores.cargoTempLog.storeName);

    return allItems.filter((item) => item.saveCargoTemperatureConfigsRequest && (imoNumber ? item.imoNumber === imoNumber : true));
};
export const putCargoTemperatureConfigsItem = async (storeItem, key) =>
    await putStoreItem(OfflineConstants.stores.cargoTempLog.storeName, storeItem, key);
export const deleteCargoTemperatureConfigsItem = async (key) => await deleteStoreItem(OfflineConstants.stores.cargoTempLog.storeName, key);
export const getCargoTemperatureConfigKeys = async () => await getStoreKeys(OfflineConstants.stores.cargoTempLog.storeName);

export const getCargoTemperatureLogItem = async (key) => await getStoreItem(OfflineConstants.stores.cargoTempLog.storeName, key);
export const getAllCargoTemperatureLogItems = async (imoNumber) => {
    const allItems = await getAllStoreItems(OfflineConstants.stores.cargoTempLog.storeName);

    return allItems.filter((item) => item.saveCargoTemperatureLogRequest && (imoNumber ? item.imoNumber === imoNumber : true));
};
export const putCargoTemperatureLogItem = async (storeItem, key) =>
    await putStoreItem(OfflineConstants.stores.cargoTempLog.storeName, storeItem, key);
export const deleteCargoTemperatureLogItem = async (key) => await deleteStoreItem(OfflineConstants.stores.cargoTempLog.storeName, key);
